module.exports = __webpack_public_path__ + "img/404.5b302d9d.png";